// src/severity.ts
import { z } from "zod";
var severitySchema = z.enum(["critical", "serious", "moderate", "minor"]);
var severityLevelSchema = z.enum(["error", "warn"]);
var legacySeverityLevelSchema = z.enum(["error", "warn", "info", "warning"]);
var SEVERITIES = severitySchema.options;
var SEVERITY_WEIGHTS = {
  critical: 10,
  serious: 5,
  moderate: 2,
  minor: 1
};
var SEVERITY_RANK = {
  critical: 4,
  serious: 3,
  moderate: 2,
  minor: 1
};
function severityLevel(severity) {
  return severity === "critical" || severity === "serious" ? "error" : "warn";
}
function severityFromLevel(level) {
  switch (level) {
    case "error":
      return "serious";
    case "warn":
    case "warning":
      return "moderate";
    case "info":
      return "minor";
  }
}
function compareSeverity(a, b) {
  return SEVERITY_RANK[b] - SEVERITY_RANK[a];
}
function maxSeverity(a, b) {
  return SEVERITY_RANK[a] >= SEVERITY_RANK[b] ? a : b;
}
function sortBySeverity(items, getSeverity) {
  return items.slice().sort((a, b) => compareSeverity(getSeverity(a), getSeverity(b)));
}

export {
  severitySchema,
  severityLevelSchema,
  legacySeverityLevelSchema,
  SEVERITIES,
  SEVERITY_WEIGHTS,
  SEVERITY_RANK,
  severityLevel,
  severityFromLevel,
  compareSeverity,
  maxSeverity,
  sortBySeverity
};
//# sourceMappingURL=chunk-V4VQB57N.js.map